const dragonsCommonNote = require('./dragons_common')

module.exports = [
  {
    text: `Полёт сапфирового дракона однажды вдохновил создание брачного танца в одном королевстве, которое, право, не стоит называть. Впечатляет то, что они до сих его танцуют`,
    author: `Физбан`,
  },
  ...dragonsCommonNote,
]
